module.exports = __webpack_public_path__ + "static/media/close-btn.5f695a8a.svg";